export const mappingConfig = [
  {
    snId: "s1t1",
    tvId: "top-s1t1",
    rotation: 2,
    mirror: true,
  },
  {
    snId: "s2t1",
    tvId: "top-s2t1",
    rotation: 1,
  },
  {
    snId: "s3t1",
    tvId: "top-s3t1",
    rotation: 1,
  },
  {
    snId: "s4t1",
    tvId: "top-s4t1",
    rotation: 2,
    mirror: true,
  },
  {
    snId: "s5t1",
    tvId: "top-s5t1",
    rotation: 1,
  },

  {
    snId: "s1t2",
    tvId: "top-s1t2",
    rotation: 1,
    mirror: true,
  },
  {
    snId: "s2t2",
    tvId: "top-s2t2",
    rotation: 2,
  },
  {
    snId: "s3t2",
    tvId: "top-s3t2",
    rotation: 1,
    mirror: true,
  },
  {
    snId: "s4t2",
    tvId: "top-s4t2",
    rotation: 2,
  },
  {
    snId: "s5t2",
    tvId: "top-s5t2",
    rotation: 0,
  },

  {
    snId: "s1t3",
    tvId: "top-s1t3",
    rotation: 0,
  },
  {
    snId: "s2t3",
    tvId: "top-s2t3",
    rotation: 0,
    mirror: true,
  },
  {
    snId: "s3t3",
    tvId: "top-s3t3",
    rotation: 0,
  },
  {
    snId: "s4t3",
    tvId: "top-s4t4",
    rotation: 1,
    mirror: true,
  },
  {
    snId: "s5t3",
    tvId: "top-s5t4",
    rotation: 1,
    mirror: true,
  },

  {
    snId: "s1t4",
    tvId: "top-s1t4",
    rotation: 2,
  },
  {
    snId: "s2t4",
    tvId: "top-s2t4",
    rotation: 1,
    mirror: true,
  },
  {
    snId: "s3t4",
    tvId: "top-s3t4",
    rotation: 2,
  },
  {
    snId: "s4t4",
    tvId: "top-s4t3",
    rotation: 1,
  },
  {
    snId: "s5t4",
    tvId: "top-s5t3",
    rotation: 2,
    mirror: true,
  },

  {
    snId: "s1t5",
    tvId: "top-s1t5",
    rotation: 0,
    mirror: true,
  },
  {
    snId: "s2t5",
    tvId: "top-s2t5",
    rotation: 1,
    mirror: true,
  },
  {
    snId: "s3t5",
    tvId: "top-s3t5",
    rotation: 0,
    mirror: true,
  },
  {
    snId: "s4t5",
    tvId: "top-s4t5",
    rotation: 1,
    mirror: true,
  },
  {
    snId: "s5t5",
    tvId: "top-s5t5",
    rotation: 1,
  },

  {
    snId: "s1t6",
    tvId: "top-s1t6",
    rotation: 2,
  },
  {
    snId: "s2t6",
    tvId: "top-s2t6",
    rotation: 0,
  },
  {
    snId: "s3t6",
    tvId: "top-s3t6",
    rotation: 2,
  },
  {
    snId: "s4t6",
    tvId: "top-s4t6",
    rotation: 0,
  },
  {
    snId: "s5t6",
    tvId: "top-s5t6",
    rotation: 2,
    mirror: true,
  },

  {
    snId: "s1t7",
    tvId: "top-s1t7",
    rotation: 1,
    mirror: true,
  },
  {
    snId: "s2t7",
    tvId: "top-s2t7",
    rotation: 2,
    mirror: true,
  },
  {
    snId: "s3t7",
    tvId: "top-s3t7",
    rotation: 1,
    mirror: true,
  },
  {
    snId: "s4t7",
    tvId: "top-s4t7",
    rotation: 2,
    mirror: true,
  },
  {
    snId: "s5t7",
    tvId: "top-s5t7",
    rotation: 0,
  },

  {
    snId: "s1t8",
    tvId: "top-s1t8",
    rotation: 0,
  },
  {
    snId: "s2t8",
    tvId: "top-s2t8",
    rotation: 1,
  },
  {
    snId: "s3t8",
    tvId: "top-s3t8",
    rotation: 0,
  },
  {
    snId: "s4t8",
    tvId: "top-s4t8",
    rotation: 2,
    mirror: true,
  },
  {
    snId: "s5t8",
    tvId: "top-s5t8",
    rotation: 1,
    mirror: true,
  },
];
